import script from "./single-card.vue?vue&type=script&setup=true&lang=js"
export * from "./single-card.vue?vue&type=script&setup=true&lang=js"

import "./single-card.vue?vue&type=style&index=0&id=7373058a&lang=scss"

const __exports__ = script;

export default __exports__